import * as THREE from "three";
import { func } from "three/examples/jsm/nodes/code/FunctionNode.js";


let chunks = [],
groups = [], boxs = [];



function Chunkgroup(name) {
    this.IsChunkGroup = true
    this.name = name;
    this.chunks = [];
    this.endrow = false;
}

function grid (chunks, groups, vectors, boxs) {
  this.IsWorldGrid = true
  this.chunks = chunks
  this.groups = groups
  this.boxs = boxs
  this.lowestrowvalue = vectors
  this.highestrowvalue = vectors * -1
}
function rttobject(rttplane,seed,rttplanetexture,rttplanemesh,sceneRTT) {
  this.plane = rttplane
  this.seed = seed
  this.texture = rttplanetexture
  this.rttmesh = rttplanemesh
  this.rttscene = sceneRTT
  
}

export function generateworldgrid(scene,tilesize) {
    ///donte touche pwease uwu
    const newpos = new THREE.Vector3(); //this stores the last tile postion to act as a way to cordinate placment of the new tile
    let rowtotal = 0; //how many in the row before adding next row
    let rowcount = 0; //how many currently in the row
    let cvector = 1; //changes the direction of placment depending on value 1 z, 2 -x, 3 -z, 4 x, 5 y, 6 -y
    let maxsteps = 0; //the number of steps before changing direction
    let steps = 0; //current amount of steps
    const worldsize = 361; //you CAN change this to generate more tiles but for normal reasons you dont need to change this
    const target = new THREE.Vector3();


    //Lets generate the grid
    for (let tile = 0; tile < worldsize; tile++) {
      const box = new THREE.Box3();

      if (rowtotal === 0){
        console.log("One")
      }
      ////place in world////
      let position = box.getCenter(target);
      if (tile > 0) {
        if (rowcount === rowtotal) {
          //Change Row
          rowcount = 1;
          rowtotal += 8;
          maxsteps += 2;
          steps = 1;
          cvector = 1;

          //move it forward
          newpos.add(
            new THREE.Vector3(position.x + tilesize, position.y, position.z)
          );
        } else {
          //Add to row

          //change postion at the end of the row
          if (steps === maxsteps) {
            if (cvector === 4) {
              cvector = 1;
              steps = 0;
            } else {
              cvector++;
              steps = 0;
            }
          }
          let d = null;

          //what postion are we going
          switch (cvector) {
            case 1:
              d = new THREE.Vector3(
                position.x,
                position.y,
                position.z + tilesize
              );
              break;
            case 2:
              d = new THREE.Vector3(
                position.x - tilesize,
                position.y,
                position.z
              );
              break;
            case 3:
              d = new THREE.Vector3(
                position.x,
                position.y,
                position.z - tilesize
              );
              break;
            case 4:
              d = new THREE.Vector3(
                position.x + tilesize,
                position.y,
                position.z
              );
              break;
            default:
              throw Error("Unregistered Vector: " + cvector);
          }
          newpos.add(d);

          rowcount++;
          steps++;
        }
      }
      //Final setting of object
      box.setFromCenterAndSize(
        new THREE.Vector3(newpos.x, tilesize / 2, newpos.z),
        new THREE.Vector3(tilesize, tilesize, tilesize)
      );
      //const obb = new OBB.fromBox3(box)

      box.rendered = false;
      box.worldcenter = false;
      box.name = "chunk";
      box.groupsid = [];
      box.id = tile;
      box.rttarget = null;
      box.mesh = null;
      box.active = true;
      box.center = newpos.toArray(); //THIS IS NOT THE CENTER ACCORDING TO WORLD BUT ITS PLACEMENT WITHIN THE GRID!! DO NOT CHANGE THIS
      box.centerv = newpos;
      chunks.push(box);
      const boxhelper = new THREE.Box3Helper(box, 0xff0000);
      scene.add(boxhelper)
      boxs.push(boxhelper)
    }

    var vectornew = creategroups(chunks, groups);
    return new grid(chunks,groups, vectornew, boxs)
  }
  function creategroups(chunks, groups) {
    const vecn = ["x: ", "y: ", "z: "];
    let vector = null;
    for (let v = 0, vi = chunks.length, groupindex = []; v < vi; v++) {
      const chunk = chunks[v];
      //check each vector
      //1, 2, 3, x, y, z
      for (let i = 0, il = chunk.center.length; i < il; i++) {

        vector = chunk.center[i];
        //name
        const j = vecn[i] + vector;
        

        if (groupindex.includes(j)) {
          //it already exist prob
          const found = groupindex.findIndex((element) => element === j);
          //add one because the group will should be after the index\

          let cg = groups[found + 1].chunks
          cg.push(chunk)
        } else {
          // it doesnt exist 
          let g = new Chunkgroup(j)
          g.chunks.push(chunk);
          groupindex.push(j, g);
          groups.push(j, g);
        }
        const found = groupindex.findIndex((element) => element === j);
        //set box's groups
        chunk.groupsid.push(found + 1);
      }
    }
    return vector
  }
